import React from "react";
import Tap from 'react-interactions';
import styled, { css } from "styled-components";

export const Tabs = ({
  root = '/',
  handleTab = () => void(0),
  theme,
  active,
  tabs = [],
}) => {
  return (

    <React.Fragment>
{/* <Scrollbars
style={{
height: '100%'
}}
> */}
{/* <div style={{
minWidth: '800px',
display: 'flex',}}> */}



    {tabs.map((tab, ind) => (

      <CssMenuLi0
        key={`tab_${ind}`}
        onClick={()=>{
          handleTab(tab['value'])
        }}
      >
        <CssMenuLi
          theme={theme}
          active={active === tab['value'] ? true : false}
          href={`${root}${active}`}
        >
          {tab['label']}


          {!!tab['counter'] && <CssCounter
            theme={theme}
            active={active === tab['value'] ? true : false}
          >{tab["counter"]}</CssCounter>}
        </CssMenuLi>
        <Tap
          scale
          waves
        />
      </CssMenuLi0>))}



      {/* </div> */}
    {/* </Scrollbars> */}
  </React.Fragment>

  )
}





export const CssMenuLi = styled.div`

  display: inline-flex;
  align-items: center;
  height: 100%;
  color: ${({active, theme}) => active && theme ? theme['colorAccent'] : theme['colorText']};
  border-bottom: 2px solid ${({active, theme}) => active && theme ? theme['colorAccent'] : 'transparent'};
  text-decoration: none;
  transition: border-bottom 150ms ease-in-out 0s;
  transition: background-color 350ms ease-in-out 0s;
  padding: 0; margin: 0;
  cursor: pointer;
  &:hover {
    border-bottom: 2px solid ${({theme}) => theme['colorAccent']};
  }
  &:active {
    background: ${({theme}) => theme['colorAccent']};
    border-bottom: 2px solid ${({theme}) => theme['colorAccent']};
  }
`


export const CssCounter = styled.span`
  margin-left: 0.6em;
  color: currentColor;
  justify-content: center;
  align-items: center;
  min-width: 24px;
  line-height: 100%;
  /* padding: 0 8px; */
  /* height: 24px; */
  padding: 0 10px 1px 10px;
  height: 18px;
  margin-bottom: -2px;
  font-size: 11px;
  display: flex;
  border: 1px solid #baceec;
  border-radius: 100px;

  color: ${({active, theme}) => active && theme ? theme['colorAccent'] : theme['colorText']};
  border: 1px solid ${({active, theme}) => active && theme ? theme['colorAccent'] : theme['colorText']};
  opacity: ${({active}) => active ? 1 : 0.3};
`;



export const CssMenuLi0 = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.05em;
  margin: 0px 36px 0 0;
  /* height: 80px; */
  height: 100%;

  @media (max-width: 991px) {
    /* height: 70px; */
    margin: 0px 24px 0 0;
  }

  @media (max-width: 767px) {
    /* height: 64px; */
    margin: 0px 16px 0 0;
  }

  @media (max-width: 479px) {

  }
`



